export const agenda = {
  agendaDuration: 'duración',
  agendaCurtainCopy: 'Copiar enlace',
  agendaCurtainFlag: 'Marcar contenido',
  agendaCurtainFlagSent: 'Contenido reportado',
  agendaLinkCopied: '¡Enlace copiado!',
  agendaStartsAt: 'Comienza a las ',
  agendaEndsAt: 'Termina a las ',
  agendaSpeakers: 'Oradores',
  agendaSeeAllSpeakers: 'Ver todos',
  agendaAddToSchedule: 'Agregar a mi agenda',
  agendaRemoveFromSchedule: 'Eliminar de mi agenda',
  agendaAddedToSchedule: '¡Añadido a mi agenda!',
  agendaRemovedFromSchedule: '¡Eliminado de mi agenda!',
  agendaCalendar: 'Calendario',
  agendaAddToCalendar: '¿Añadir al calendario del sistema?',
  agendaCalendarSkip: 'Saltar',
  agendaCalendarAdd: 'Añadir',
  agendaNow: 'AHORA',
  agendaModerators: 'Moderadores'
}
